import { BrazilDate } from "../../utils/BrazilDate";

/** Tempo mínimo em rota antes de permitir finalizar na aba Operando. */
export const MIN_MINUTOS_FINALIZAR_ENTREGA = 5;

export function getMsRestantesParaFinalizar(
  dataInicio: string | undefined | null
): number {
  if (!dataInicio) return 0;
  const inicio = BrazilDate.parseAsBrazil(dataInicio);
  const decorridoMs = Date.now() - inicio.getTime();
  return Math.max(
    0,
    MIN_MINUTOS_FINALIZAR_ENTREGA * 60 * 1000 - decorridoMs
  );
}
